import React from "reactn";
import "./RequestInfo.css";
import { withRouter } from "react-router-dom";
import BaseModal from "./baseModal/BaseModal";
import {
  CONTENT_BLOCK
} from "./baseModal/FieldTypes";

class ShareOnlineLinkModal extends React.PureComponent {
    constructor(props) {
      super(props);
    }

    getBaseModalFields = () => {
        const roomLink = {
            type: CONTENT_BLOCK,
            data: {
                name: "Copy and paste the link below:",
                content: `https://dreamschools.daily.co/${this.props.roomName}`,
                textStyles: {
                    "overflowWrap": "break-word",
                    "wordBreak": "break-all"
                  },
            }
        }

        const fields = [];

        fields.push(roomLink);

        return fields;
    }

    getBaseModalProps = () => {
        return {
          title: "Share Online Link",
          fields: this.getBaseModalFields(),
          height: "300px",
          midSectionHeight: "52vh",
          handleClose: () => this.props.onClose()
        };
    };

    render() {
        return <BaseModal {...this.getBaseModalProps()}/>
    }
}

export default withRouter(ShareOnlineLinkModal);